import { useMemo } from 'react'

import { StarRatingAnalyticsData } from 'components/common/StarRating'
import { useGalleryAssignment } from './GalleryAssignment.context'
import { useUserData } from 'components/contexts/UserDataContext'

interface StarRatingAnalyticsOverrides {
  creativeId?: string | null
  orderId?: string | null
  realtyId?: string | null
}

export function useStarRatingAnalyticsData(overrides?: StarRatingAnalyticsOverrides): StarRatingAnalyticsData {
  const { product, realtyId, creative, assignmentData } = useGalleryAssignment()
  const { baseUserData, currentUserWorkspace } = useUserData()

  return useMemo<StarRatingAnalyticsData>(() => {
    const creativeId = overrides?.creativeId !== undefined
      ? overrides.creativeId
      : (creative?.creativeId ?? null)

    const orderId = overrides?.orderId !== undefined
      ? overrides.orderId
      : (assignmentData && 'dealId' in assignmentData ? String(assignmentData.dealId) : null)

    const resolvedRealtyId = overrides?.realtyId !== undefined
      ? overrides.realtyId
      : ((assignmentData && 'property' in assignmentData ? assignmentData.property?.id : undefined) ?? realtyId ?? null)

    return {
      creativeId,
      country: baseUserData?.country ?? null,
      workspaceId: currentUserWorkspace?.id ?? null,
      productKind: product?.kind ?? null,
      productCategory: product?.category ?? null,
      orderId,
      realtyId: resolvedRealtyId
    }
  }, [overrides?.creativeId, overrides?.orderId, overrides?.realtyId, creative?.creativeId, baseUserData?.country, currentUserWorkspace?.id, product, assignmentData, realtyId])
}
